import { URL_LABEL } from "../../../../../content/index.content";

const stockStats = ({ language, isSavedUser }) => {
  return {
    title: "Stock Stats",
    subtitle:
      "Spy on inventory level and sales of your competitors on Amazon for a given period",
    href: isSavedUser
      ? "https://chromewebstore.google.com/detail/amzscout-stock-stats-amaz/liobflkelkokkacdemhmgkbpefgaekkm?utm_source=site&utm_medium=amzscout&utm_campaign=menu"
      : `/stock-stats/?${URL_LABEL}`,
    isLink: !isSavedUser,
    isBlank: isSavedUser,
  };
};

export default stockStats;
